/*
 * 封装 axios 请求
 */
import router from "../router/index"
import axios from "axios";
import {
    Message,
    MessageBox
} from 'element-ui';
import Vue from 'vue';

const request = axios.create({})
request.defaults.headers.post['Content-Type'] = 'application/json'

// 请求拦截器
request.interceptors.request.use(

    function(config) {
        // function getCookie(cname) {
        //   var name = cname + "=";
        //   var ca = document.cookie.split(';');
        //   for (var i = 0; i < ca.length; i++) {
        //     var c = ca[i].trim();
        //     if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        //   }
        //   return "";
        // }
        // // Do something before request is sent
        // //  sessionStorage.setItem("authToken", "f9f06473-e76a-435a-bbfa-7ff20ecc529b")
        // let token = 'bab1b882-0d5f-409e-ba1e-1b7b9e85585d' //获取token
        // let token = 'test'
        let token = window.localStorage.getItem("token")
            // token = localStorage.getItem('token')
            // token = localStorage.getItem('token')
            // config.headers.authToken = token //统一设置token
        if (token) {
            //将token放到请求头发送给服务器,将tokenkey放在请求头中
            config.headers.authToken = token;
            //也可以这种写法
            // config.headers['authToken'] = Token;
        } else {
            config.headers.authToken = '';
        }



        // // config.headers['Content-Type'] = 'application/json' 

        // // let token = 'test'


        return config
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error)
    }
)

// 响应拦截器
request.interceptors.response.use(
    function(response) {
        switch (response.data.code) {
            case 0:
                return response;
            case -1:
                // Message({
                //   showClose: true,
                //   message: response.data.msg,
                //   type: 'warning'
                // });
                return response;
            case -2:
                localStorage.clear();
                // MessageBox('登录已过期，请重新登录', '提示', {
                //     confirmButtonText: '确定',
                //     cancelButtonText: '取消',
                //     type: 'warning'
                // }).then(() => {
                //     localStorage.clear();
                //     if (location.href.indexOf("#reloaded") == -1) {
                //         location.href = location.href + "#reloaded";
                //         location.reload();
                //     } else {
                //         location.reload();
                //     }
                //     // router.push('login')
                // }).catch(() => {

                // });
                break;
            default:
                return response;

        }
    },
    function(error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if (error.response.data.code == -2) {
            localStorage.clear();
            // Message({
            //     message: "登录已过期，请重新登录",
            //     type: 'warning'
            // });
            // if (localStorage.getItem('viewHomeFlag')) {
            //     location.replace('http://smart.hogdata.cn:25776/screen/#/ViewHome8')
            // } else {
            //     window.setTimeout(() => {
            //         localStorage.clear();
            //         if (location.href.indexOf("#reloaded") == -1) {
            //             location.href = location.href + "#reloaded";
            //             location.reload();
            //         } else {
            //             location.reload();
            //         }
            //         // router.push('index')
            //     }, 2000)
            // }

            // router.push('/login')
        } else {
            // Message({
            //   message: error.response.data.message,
            //   type: 'warning'
            // });
        }

        return Promise.reject(error);
    }
)

export default request